<template>
  <div class="app">
    <el-container>
      <el-header height='60px' >
        <HEAD index = '1' step="0"></HEAD>
      </el-header>
      <el-main>
        <FLOW index='2'></FLOW>
        <div class="orderBox">
          <div class="orderHead">
            <p>待支付订单</p>
            <p>应付：<span class="price"><span class="rmb">￥</span>{{money}}</span><i @click="show1 = !show1" :class="show1?'':'rotate'" class="el-icon-arrow-down"></i></p>
          </div>
          <el-collapse-transition>
            <div v-show="show1">
              <div class="orderForm transition-box">
            <el-table
              :data="tableData"
              style="width: 100%"
              :header-cell-style="changeHeaderCellStyle"
              :cell-style="changeCellStyle"
              :span-method="objectSpanMethod">
              <el-table-column
                prop="pid"
                label="订单号"
                width="220"
                :cell-style="{margin:200}">
<!--                <template slot-scope="scope">-->
<!--                 {{scope.row.pid}} <span class="details">详情</span>-->
<!--                </template>-->
              </el-table-column>
              <el-table-column
                prop="name"
                label="收件人"
                width="150">
              </el-table-column>
              <el-table-column
                prop="address"
                label="收件地址"
                width="374">
              </el-table-column>
              <el-table-column
                prop="time"
                label="下单时间"
                width="200">
              </el-table-column>
              <el-table-column
                prop="PrintCost"
                label="打印费用"
                width="122">
              </el-table-column>
              <el-table-column
                prop="postage"
                label="邮费"
                width="122">
              </el-table-column>
            </el-table>
          </div>
            </div>
          </el-collapse-transition>
        </div>
        <div class="payBox">
          <p class="pB-head">支付方式</p>
          <div class="pb-conent">
            <div class="pay-type">
              <div class="alipayBtn" @click="pay('alipay')" :class="payType == 'alipay'?'active':''">
                <img src="@/assets/img/zhifub_23.png">
                支付宝支付
              </div>
              <div class="wxpayBtn" @click="pay('wx')" :class="payType == 'wx'?'active':''">
                <img src="@/assets/img/weixin_27.png">
                微信支付
              </div>
            </div>
            <div class="payInfo" v-show="payType">
              <div class="payTypeName">
                <span v-show="payType == 'alipay'">支付宝扫码支付</span>
                <span v-show="payType == 'wx'">微信扫码支付</span>
              </div>
              <div class="payTypeInfo">
                <div class="codeBox">
                 <div v-show="!loadingCode">
                   <div class="qrcode" ref="qrCodeUrl"></div>
                 </div>
                  <div v-show="isTimeOut" class="overtime">
                    <div class="overtime-C" @click="pay(payType)">
                      <img src="@/assets/img/refresh.png">
                      <p class="overtimeText">二维码已过期</p>
                      <p class="refresh">点击刷新</p>
                    </div>
                    <div class="mask"></div>
                  </div>
                  <div v-show="loadingCode" class="loding">
                    <img src="@/assets/img/loading2.gif">
                  </div>
                </div>
                <div class="right">
                  <p>应付金额：<span class="payAmunt">￥<span class="amount">{{money}}</span></span></p>
                  <div class="tips">
                    <p><span class="grey">订单号：</span>{{ tableData[0].pid }}<span @click="copy" class="copy" id="express_info_right" :data-clipboard-text="tableData[0].pid">复制保存</span></p>
<!--                    <p><span class="grey">提示：-&#45;&#45;&#45;&#45;</span></p>-->
                  </div>
                  <el-button class="done"   @click="ToInquire">
                    已完成
                  </el-button>
                  <!-- <div >已完成</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="fiexBox">
          <div class="kefu" @click="openKf">联系客服</div>
          <div class="shouchang" @click="addFavorite">收藏页面</div>
        </div>
      </el-main>
      <el-footer height='60px'>
        <div class="footer">
          {{FOOTER}}
        </div>
      </el-footer>
      <el-dialog
        :visible.sync="dialogVisibleSuccess"
        top="30vh"
        width="306px">
        <div class="dialogCon">
          <img src="@/assets/img/paymentSuccess.png">
          <p>恭喜您</p>
          <p>本次交易支付成功</p>
          <p class="tips">{{endTime}}秒后跳转<span class="Aurl" @click="toCX">订单查询</span></p>
          <div class="Mybtn" @click="toCX">订单查询</div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="dialogVisibleFail"
        top="30vh"
        width="306px">
        <div class="dialogCon">
          <img src="@/assets/img/paymentFailure.png">
          <p>支付失败</p>
          <p class="Ftips">支付遇到问题，请尝试<span class="Aurl">重新支付</span></p>
          <div class="Mybtn Fail-b" @click="openKf">联系客服</div>
        </div>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import flow from '../components/flow.vue';
import head from "../components/head.vue";
import QRCode from 'qrcodejs2';
import common from '../commons/common';

export default {
  components: {
    FLOW:flow,
    HEAD:head
  },
  data () {
    return {
      toDecimal2:  common.toDecimal2,
			FOOTER: common.FOOTER,
      tableData: [{
        pid: '',
        name: '',
        address: '',
        time:'',
        PrintCost:'',
        postage:'',
      }],
      show1:true,
      payType:'',
      dialogVisibleSuccess:false,
      dialogVisibleFail:false,
      time:200,
      paying:false,
      polling:false,
      timer:'',
      isTimeOut:false,
      loadingCode:false,
      oid:'',
      money:'0', // 总金额
      endTime:7,
    }
  },
  methods: {
      pay(type){
       this.isTimeOut = false
       this.loadingCode = true
      if(!this.paying){
        this.time = 200
        this.payType = type
        this.paying = true
        this.polling = true
        clearTimeout(this.timer)
        let res = this.Api.payOrder({oid:this.oid,pay_type:type})
        res.then((response) => {
          if(response.data.codeMsg == "success"){
            this.creatQrCode(response.data.data.qrlink)
            this.poll(this.oid)
            this.loadingCode = false
          }else{
            this.$message.error(response.data.codeMsg || '二维码刷新失败')
          }
          this.paying= false
          this.polling = false
        })
        .catch((err) => {
          this.$message.error('当前无网络');
          this.paying= false
          this.polling = false
        })
      }
    },
      creatQrCode(text) {
        // 清除二维码重新生成
      this.$refs.qrCodeUrl.innerHTML = ''
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: text, // 需要转换为二维码的内容
        width: 155,
        height: 155,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
      poll(oid){
        let a = oid
        let that = this
        let res =  this.Api.payStatus(oid)
        res.then((res) => {
          if(res.data.code == -1) {
            if(this.time > 0 && !this.polling){
              this.time--
              this.timer = setTimeout(() => {
                this.poll(a)
              },1000)
            }
          }else {
            this.loadingCode = false
            this.dialogVisibleSuccess = true
            this.reduceTime()
            var curTime = new Date().getTime();
            localStorage.setItem('time', curTime)
            localStorage.setItem('oid', oid);
            setTimeout(function (){
              that.toCX()
            },7*1000)
          }
          if(this.time <= 0){
            this.isTimeOut = true
            this.loadingCode = false
          }
        })
      .catch((err) => {
        this.$message.error('当前无网络');
      })
    },
      reduceTime(){
          setInterval(() =>{
            if(this.time > 0){
              this.endTime --
            }
          },1000)
      },
      copy(){
      let clipboard = new this.clipboard("#express_info_right");
      let that = this
      clipboard.on('success', function () {
        that.$message({
          message: '复制成功',
          type: 'success'
        });
        clipboard.destroy();
      });
      clipboard.on('error', function () {
        that.$message.error('复制失败');
      });
    },
      ToInquire(){
        this.Api.query(this.tableData[0].pid)
          .then((res) => {
            if(res.data.code == -1){
              this.$message.error('订单未支付');
            }
            if(res.data.code == 200){
              if(res.data.data){
                this.$router.push({
                  path: '/inquire',
                  query: {
                    oid: this.oid
                  }
                })
              }
            }
          })
          .catch((err) => {
            this.$message.error('当前无网络');
          })
      },
      toCX(){
        localStorage.setItem('oid', this.oid);
        this.$router.push({
          path: '/inquire',
          query: {
            oid: this.oid
          }
        })
      },
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
          if (rowIndex % 2 === 0) {
            return {
              rowspan: 2,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },
      changeCellStyle(row, column, rowIndex, columnIndex) {
        if (row.column.label === "订单号") {
          return {paddingLeft:"20px"}; // 修改的样式
        }
        if (row.column.label === "打印费用" || row.column.label === "邮费"){
          return {color:"#126eac"};
        }
      },
      changeHeaderCellStyle(row,column,rowIndex,columnIndex) {
        if (row.column.label === "订单号") {
          return {paddingLeft:"20px",background:'#f5f5f6',color:'#333333'};
        }
        return {background:'#f5f5f6',color:'#333333',fontWeight:500}
      },
    addFavorite(){
		  common.addFavorite(this)
    },
    async preCreateOne() {
      if(this.$route.params.orderData) { // 第一次使用路由传值,防止存储异步
        this.orderData = this.$route.params.orderData
      }else if(localStorage.getItem('orderData')){ // 刷新使用本地存储
        this.orderData = JSON.parse(localStorage.getItem('orderData'));
      }else{
        this.$router.push('/')
        return
      }
        this.tableData[0].pid = this.orderData.oid
        this.tableData[0].name = this.orderData.receive_name
        this.tableData[0].time = this.orderData.created
        this.tableData[0].postage = '￥' + this.toDecimal2(this.orderData.shipping)
        this.tableData[0].address = this.orderData.receive_addr
        let a = this.orderData.money - this.orderData.shipping
        this.tableData[0].PrintCost = '￥' +  this.toDecimal2(Math.floor(a * 100) / 100)
        this.money = this.toDecimal2(this.orderData.money)
        this.oid = this.orderData.oid
    },
    openKf(){
      window.open(common.urlKEFU)
    }
  },
  created(){
    this.preCreateOne()
  },
  beforeDestroy(){
    this.polling = true
    clearTimeout(this.timer)
  }
}
</script>

<style lang="less" scoped>
  .app{
    width: 100%;
    height: 100%;
    min-height: calc(100%);
    min-height: 850px;
    background: #f8f8f8;
    font-size: 14px;
  }
  p{
    margin: 0;
    padding: 0;
  }
  .el-header{
    background:#fff;
    .head{
      background: #fff;
      .headerS{
        div{
          line-height:60px;
          img{
            vertical-align: middle;
          }
        }
        ul{
          li{
            &:first-child{
              color: #126eac;
            }
          }
        }
      }
    }
  }
  .el-main {
    width: 1250px;
    margin: 0 auto;
    padding: 0;
    position: relative;
    overflow: visible;
    .orderBox {
      background: #fff;
      .orderHead {
        height: 60px;
        padding: 0 30px;
        line-height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px dotted #ede9e9;
        p{
          position: relative;
          margin-right: 34px;
          .el-icon-arrow-down {
            margin-left: 14px;
            font-size: 20px;
            position: absolute;
            top: 22px;
            right: -34px;
            cursor: pointer;
            color: #a5a5a5;
            transition: all .3s;
          }
          .rotate{
            transform: rotate(180deg)
          }
        }
        .rmb {
          font-size: 14px;
        }
        .price {
          font-size: 18px;
          color: #126eac;
        }
      }
      .orderForm {
        padding: 20px 30px 30px 30px;
        .el-table{
          border: 1px solid #eee;
          border-bottom: none;
          &:before{
            height: 0;
          }
          .details {
            color: #126ead;
            margin-left: 10px;
            cursor: pointer;
          }
        }
      }
    }
    .payBox{
      background: #fff;
      margin-top: 20px;
      padding-bottom: 40px;
      .pB-head {
        padding-left: 30px;
        height: 56px;
        line-height: 56px;
        color: #333;
        border-bottom: 1px dotted #eee;
      }
      .pb-conent{
        padding-left: 30px;
        .pay-type{
          display: flex;
          margin-top: 26px;
          img {
            vertical-align: middle;
            margin-top: -6px;
            margin-right: 16px;
          }
          .alipayBtn,.wxpayBtn {
            width: 170px;
            height: 50px;
            line-height: 50px;
            background: #edf3ff;
            color: #545454;
            border-radius: 5px;
            border: 1px solid #c7daff;
            box-sizing: border-box;
            text-align: center;
            cursor: pointer;
          }
          .active {
            background: url(../assets/img/checkeds.png);
            background-size: 100% 100%;
          }
          .wxpayBtn {
            margin-left: 16px;
          }
        }
        .payInfo {
          width: 560px;
          height: 258px;
          margin-top: 12px;
          border: 1px solid #f4f4f4;
          border-radius: 4px;
          .payTypeName {
            color: #666666;
            padding-left: 20px;
            height: 48px;
            line-height: 48px;
            border-bottom:1px solid #f4f4f4;
          }
          .payTypeInfo {
            display: flex;
            padding-top: 26px;
            padding-left: 20px;
            .codeBox {
              width: 156px;
              height: 156px;
              border: 1px solid #f3f3f3;
              position: relative;
              .overtime{
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                .overtime-C {
                  width: 100%;
                  height: 100%;
                  z-index: 10;
                  position: absolute;
                  color: #fff;
                  text-align: center;
                  img {
                    margin-top: 24px;
                  }
                  .overtimeText {
                    margin-top: 14px;
                    margin-bottom: 6px;
                  }
                  .refresh{
                    cursor: pointer;
                  }
                }
                .mask{
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  top: 0;
                  left: 0;
                  background: #000;
                  opacity: .6;
                }
              }
              .loding {
                position: absolute;
                width: 100%;
                top: 42px;
                text-align: center;
              }
            }
            .right {
              margin-left: 34px;
              p{
                color:#545454;
                font-weight: 600;
                &:first-child{
                  margin-top: -7px;
                }
                .payAmunt {
                  font-size: 18px;
                  color: #0d81fc;
                }
                .amount {
                  font-size: 36px;
                }
              }
              .tips {
                font-size: 12px;
                background: #f8f8f8;
                width: 284px;
                height: 60px;
                padding: 4px 0 0 10px;
                box-sizing: border-box;
                margin: 10px 0 16px 0;
                p{
                  font-weight: normal;
                  line-height: 24px;
                  &:first-child{
                    margin-top: 14px ;
                  }
                }
                .copy {
                  color: #ff8400;
                  text-decoration: underline;
                  margin-left: 12px;
                  cursor: pointer;
                }
              }
              .done {
                padding: 0;
                margin: 0;
                line-height: 30px;
                height: 30px;
                width: 136px;
                background: #f8f8f8;
                line-height: 30px;
                color: #999999;
                text-align: center;
                cursor:pointer;
              }
              .doneS {
                background: #0d81fc;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
  .fiexBox {
    position: absolute;
    top: 240px;
    right: -63px;
  }
  .kefu,.shouchang {
    width: 43px;
    height: 43px;
    border: 1px solid #e7e7e7;
    background: #fff;
    color: #9e9e9e;
    font-size: 12px;
    padding: 4px;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
    &:hover{
      background: #0d81fc;
      color: #fff;
    }
  }
  .shouchang{
    margin-top: 10px;
  }
  .el-footer{
    // position: absolute;
    // bottom: 0;
    width: 100%;
    .footer{
      font-size: 12px;
      text-align: center;
      margin-top: 10px;
      color: #bebebe;
      line-height: 30px;
    }
  }
  .dialogCon {
    text-align: center;
    img{
      margin-top: -44px;
      margin-left: 12px;
    }
    p {
      color: #b1b1b1;
      font-size: 18px;
      font-weight: 200;
      margin-top: 6px;
    }
    .tips {
      font-size: 14px;
      margin-top: 12px;
      .Aurl {
        cursor: pointer;
        color: #eb4029;
        text-decoration: underline;
      }
    }
    .Mybtn {
      width: 150px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      background: linear-gradient(90deg,#ffbb56, #f8d859);
      border-radius: 40px;
      color: #fff;
      margin-top: 34px;
      margin-left: 56px;
      cursor: pointer;
    }
    .Ftips{
      font-size: 16px;
      margin-top: 12px;
      .Aurl {
        cursor: pointer;
        color: #eb4029;
        text-decoration: underline;
      }
    }
    .Fail-b{
      margin-top: 60px;
    }
  }
  .el-table /deep/ .th.el-table_1_column_1.is-leaf.el-table__cell{
    padding-left: 20px;
  }
  .el-container {
      height: 100%;
  }
  @media (max-width: 1400px){
      .fiexBox{
          display: none;
      }
  }
</style>



// WEBPACK FOOTER //
// src/pages/confirm.vue